/**
 * Daily Jackpot States:
 * https://confluence/display/SECTION8/Daily+Jackpot+mechanism
 */
export enum DAILY_JACKPOTS_STATES {
    SUPER_COLD = 1,
    COLD = 2,
    HOT = 3,
    SUPER_HOT = 4,
    HOT_100 = 5,
}

export interface IJackpotToastersThresholdDetails {
    threshold: number,
    toasterName: string,
    contentText: string,
    titleText?: string
}

export interface IToasterPerGame {
    thresholds: IJackpotToastersThresholdDetails[],
    gameTypes: number[],
    showGameIcon: boolean
}

export const DAILY_JACKPOTS_AMOUNT_THRESHOLDS_DEFAULT: IJackpotToastersThresholdDetails[] = [
    {
        threshold: 10000000,
        toasterName: 'DAILY_JP_ALERT_100K',
        contentText: 'jackpot_amount_threshold_text_template5'
    },
    {
        threshold: 9000000,
        toasterName: 'DAILY_JP_ALERT_90K',
        contentText: 'jackpot_amount_threshold_text_template7'
    },
    {
        threshold: 8000000,
        toasterName: 'DAILY_JP_ALERT_80K',
        contentText: 'jackpot_amount_threshold_text_template6'
    },
    {
        threshold: 7500000,
        toasterName: 'DAILY_JP_ALERT_75K',
        contentText: 'jackpot_amount_threshold_text_template5'
    },
    {
        threshold: 6000000,
        toasterName: 'DAILY_JP_ALERT_60K',
        contentText: 'jackpot_amount_threshold_text_template4'
    },
    {
        threshold: 5000000,
        toasterName: 'DAILY_JP_ALERT_50K',
        contentText: 'jackpot_amount_threshold_text_template3'
    },
    {
        threshold: 4000000,
        toasterName: 'DAILY_JP_ALERT_40K',
        contentText: 'jackpot_amount_threshold_text_template2'
    },
    {
        threshold: 2500000,
        toasterName: 'DAILY_JP_ALERT_25K',
        contentText: 'jackpot_amount_threshold_text_template1'
    }
];

export const TWILIGHT_JACKPOTS_AMOUNT_THRESHOLDS_DEFAULT: IJackpotToastersThresholdDetails[] = [
    {
        threshold: 3000000,
        toasterName: 'TWILIGHT_JP_ALERT_30K',
        contentText: 'jackpot_amount_threshold_text_template6'
    },
    {
        threshold: 2000000,
        toasterName: 'TWILIGHT_JP_ALERT_20K',
        contentText: 'jackpot_amount_threshold_text_template4'
    },
    {
        threshold: 1500000,
        toasterName: 'TWILIGHT_JP_ALERT_15K',
        contentText: 'jackpot_amount_threshold_text_template3'
    },
    {
        threshold: 1200000,
        toasterName: 'TWILIGHT_JP_ALERT_12K',
        contentText: 'jackpot_amount_threshold_text_template2'
    },
    {
        threshold: 750000,
        toasterName: 'TWILIGHT_JP_ALERT_7.5K',
        contentText: 'jackpot_amount_threshold_text_template1'
    }
];

